import { Component, ChangeDetectorRef, ViewChild, AfterViewInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { HttpService } from 'src/app/http.service';
import { TableComponent } from '../table/table.component';

@Component({
  selector: 'app-search-player',
  templateUrl: './search-player.component.html',
  styleUrls: ['./search-player.component.scss']
})
export class SearchPlayerComponent implements AfterViewInit {

  
  public data: any = {search:true};
  public company_uuid;
  public setting : any = {};
  @ViewChild('f') f : NgForm
  @ViewChild("table", { static: true }) tb!: TableComponent;

  constructor(private http: HttpService,  private cdr: ChangeDetectorRef) {
    this.company_uuid = this.http.getStaticSelectedCompany();

    this.setting = 
      { post: {url: '/admin/player/get', data: this.data},
        disabled_pagenat: false,
        fields: [
          {label: 'No', type: 'index'}, 
          {label: 'Code', type: 'string', key: 'code'}, 
          {label: 'Name', type: 'string', key: 'name'}, 
          {label: 'Mobile', type: 'string', key: 'mobile'}, 
          {label: 'DOB', type: 'date', key: 'dob'}, 
          {label: 'Wallet Balance', type: 'price', key: 'wallet'}, 
          {label: 'Status', type: 'status', key: 'status'}, 
          {label: 'Can Login', type: 'status', key: 'can_login'}, 
          {label: 'Is Agent', type: 'yesno', key: 'is_agent'}, 
          {label: 'View', type: 'link', key: 'uuid', 'link': '/lo/' + this.company_uuid + '/player/form', hide: true},
          {label: 'Daily', type: 'link', key: 'uuid', 'link': '/lo/' + this.company_uuid + '/player/daily', hide: true},
          {label: 'Topup/Withdraw/Transfer', type: 'link-status', key: 'uuid', 'link': '/lo/' + this.company_uuid + '/topup-withdraw/form', hide: true},
          {label: 'Seamless Wallet', type: 'query-link-status', key: 'uuid', 'link': '/lo/' + this.company_uuid + '/wallet-topup-withdraw', query_key: 'player'},
          {label: 'Transfer Wallet', type: 'query-link-status', key: 'uuid', 'link': '/lo/' + this.company_uuid + '/auto-topup-withdraw', query_key: 'player'},
          {label: 'Delete', type: 'delete', key: 'uuid', table: 'player', title: 'name', hide: true},
        ]}  
  }

  ngAfterViewInit() {
    this.tb.is_loading = false;
  }

  async submit() {

    this.setting.post.data = this.data;

    if (!this.data.code && !this.data.mobile && !this.data.name) {
      return;
    }

    if (this.data.mobile) {
      this.data.mobile = String(this.data.mobile).trim();
    }

    this.data.status = 1;

    this.tb.setSetting = this.setting;
  }

  reset() {
    this.f.resetForm();
    this.tb.reset();
  }

}
